"use strict";

exports.__esModule = true;
exports["default"] = Renren;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Renren(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h435.207L512 76.795V512H76.793L0 435.203",
    fill: "#1B5DA2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M435.207 0L512 76.795h-76.793",
    fill: "#3F84C5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M435.207 76.795L512 153.585v-76.79",
    fill: "#17467D"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M76.793 512L0 435.203h76.793",
    fill: "#3F84C5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M153.588 512l-76.795-76.797V512M249.576 512H512V319.11L289.332 96.442c0 112.166.754 202.412 112.77 271.342-13.758 20.402-31.742 37.793-52.605 50.785-43.84-27.2-69.082-59.098-93.568-103.387-24.34 44.29-49.587 76.188-93.425 103.387-10.43-6.492-20.104-14.05-29.023-22.668L249.576 512z",
    fill: "#17467D"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M289.332 96.443c-11.03-2.115-22.066-3.174-33.404-3.174-11.188 0-22.225 1.058-33.26 3.173 0 112.166-.906 202.412-112.77 271.342 13.756 20.402 31.746 37.793 52.605 50.785 43.838-27.2 69.084-59.098 93.424-103.387 24.486 44.29 49.73 76.188 93.568 103.387 20.863-12.992 38.848-30.383 52.605-50.785-112.014-68.93-112.768-159.176-112.768-271.342z",
    fill: "#FFF"
  })));
}